import { Globe } from '../../common/icons';

const NavbarGoogleTranslate = (props) => {
  const { gold, hasSelectTheme } = props;
  let globeIconClassName = '';

  if (gold) {
    globeIconClassName = 'navbar-google-translate-icon-gold';
  }

  if (hasSelectTheme) {
    globeIconClassName = 'navbar-google-translate-icon-select';
  }

  return (
    <div className='navbar-google-translate-container'>
      <Globe className={globeIconClassName} />
      <div id="google-translate" />
    </div>
  );
};


export default NavbarGoogleTranslate;
